// Campus photo for /colleges/appalachian-state-university: CC BY-SA 2.0, by chucka_nc, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AAppalachian_State_University.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/appalachian-state-university/; credited under the photo.
const photo = {
    "slug": "appalachian-state-university",
    "alt": "A tall brick tower and brick building beside a creek, a walkway and tennis courts on the Appalachian State University campus in Boone",
    "src": "/colleges/appalachian-state-university/campus-1600.webp",
    "srcSmall": "/colleges/appalachian-state-university/campus-800.webp",
    "srcMid": "/colleges/appalachian-state-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/appalachian-state-university/og.jpg",
    "title": "Appalachian State University",
    "author": "chucka_nc",
    "license": "CC BY-SA 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/2.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AAppalachian_State_University.jpg",
    "read": "2026-10-01"
};

export default photo;
